export const setLandingFalse = (state) => {
  return { ...state, landingPage: false }
}